import { Component, OnInit } from '@angular/core';
import { CHECKOUT, VERIFY, GETADDRESS, CARTVIEW, IMAGE } from 'src/app/config';
import { ApiService } from 'src/app/api.service';
import { Router } from '@angular/router';
import { WindowRefService } from 'src/app/window-ref/window-ref.service';

@Component({
    selector: 'app-checkout',
    templateUrl: './checkout.component.html',
    styleUrls: ['./checkout.component.css'],
    
})


  export class CheckoutComponent implements OnInit {
    addresses: any;
    currentAddress: any;
    clicked:any;
    uid: string;
    discount:any;
    discountamount:any;
    products: any;
    callshadow:any;
    baseurl= IMAGE+"/product/";
    priceWeight:any;
    total = {'weight':0,'price':0,'making_charges':0,'tax':0,'igst':0,'sgst':0,'cgst':0};
    final:any;
    disamt: any;
    realFinal:any;
    feedback= '';
    paymnetmode:any;
    transaction: any;
    showOfflineDetails:boolean = false;
  totalw: string;
    constructor(private api:ApiService,private router:Router, private winRef: WindowRefService) { 
        this.uid=this.api.uid;
  
      this.api.Get(CARTVIEW+"?user_id="+this.uid).then(data=>{
        this.products=data['data'];
        this.priceWeight = this.api.calculate(this.products,this.api.igst);
        let i = 0;
        if(this.priceWeight){
          console.log(this.priceWeight);
           this.priceWeight.forEach(element => {
            if(element.off != 0){
              this.total.igst += element.oigst*this.products[i].count;
              this.total.cgst += element.ocgst*this.products[i].count;
              this.total.sgst += element.osgst*this.products[i].count;
              this.total.tax += element.offtax*this.products[i].count;
              this.total.price +=element.off*this.products[i].count;
            }else{
              this.total.igst += element.igst*this.products[i].count;
              this.total.cgst += element.cgst*this.products[i].count;
              this.total.sgst += element.sgst*this.products[i].count;
              this.total.tax += element.tax*this.products[i].count;
              this.total.price +=element.price*this.products[i].count;
            }
          
           this.total.weight +=element.weight*this.products[i].count;
           this.total.making_charges +=element.making*this.products[i].count;
           console.log(element)

         });}
          this.totalw = this.total.weight.toFixed(2); 
          this.final = this.total.price;
          this.realFinal = this.final;
      }).catch(d=>{
        if( d.status == 503){
          this.api.onFail('Your session is expired please login again','Login');
          this.api.setGoto();
          this.api.setlogin(0);
          this.api.logout();
          setTimeout(() => {
          this.router.navigate(['/login']);
          },1000);
        } else{
          console.log(d);
        }
  });
      this.api.Get(GETADDRESS).then(data => {
        this.addresses = data['data'];
        this.currentAddress = this.addresses[0];
        this.clicked = this.currentAddress.id;
      }).catch(d=>{
        if( d.status == 503){
          this.api.onFail('Your session is expired please login again','Login');
          this.api.setGoto();
          this.api.setlogin(0);
          this.api.logout();
          setTimeout(() => {
          this.router.navigate(['/login']);
          },1000);
        }
  });
    }
    check(value){
      this.final = this.realFinal;
      console.log(this.feedback)
      this.api.Put2(VERIFY,'',{'coupan':value.discountname}).then(data=>{
        if(data['message'] == "Wrong Coupan"){
          this.api.onFail('Not a Valid Coupan Code','Invalid Coupan');
         } else {
          this.api.onSuccess('Coupen Code Successfully Applied','Congratulations');
          this.discountamount = data['data'];
          if  (this.discountamount.offertype == 'Percentage'){
            this.disamt = this.final * (this.discountamount.value/100);
            this.final = this.final - this.disamt;
          } else {
            this.disamt = this.discountamount.value;
            this.final = this.final - this.disamt;
          }
         }
      }).catch(d=>{
        if( d.status == 503){
          this.api.onFail('Your session is expired please login again','Login');
          this.api.setGoto();
          this.api.setlogin(0);
          this.api.logout();
          setTimeout(() => {
          this.router.navigate(['/login']);
          },1000);
        } else{
          console.log(d);
        }});
    }
    
    again(){
      this.total = {'weight':0,'price':0,'making_charges':0,'tax':0,'igst':0,'sgst':0,'cgst':0};
      this.totalw = null; 
      this.final = null;
      this.realFinal = null;

      this.api.Get(CARTVIEW+"?user_id="+this.uid).then(data=>{
        this.products=data['data'];
        console.log(this.products);
        this.priceWeight = this.api.calculate(this.products,this.api.igst);
        let i = 0;
        console.log(this.priceWeight);
        if(this.priceWeight){
           console.log(this.priceWeight);
           this.priceWeight.forEach(element => {
            if(element.off != 0){
              this.total.igst += element.oigst*this.products[i].count;
              this.total.cgst += element.ocgst*this.products[i].count;
              this.total.sgst += element.osgst*this.products[i].count;
              this.total.tax += element.offtax*this.products[i].count;
              this.total.price +=element.off*this.products[i].count;
            }else{
              this.total.igst += element.igst*this.products[i].count;
              this.total.cgst += element.cgst*this.products[i].count;
              this.total.sgst += element.sgst*this.products[i].count;
              this.total.tax += element.tax*this.products[i].count;
              this.total.price +=element.price*this.products[i].count;
            }
          
           this.total.weight +=element.weight*this.products[i].count;
           this.total.making_charges +=element.making*this.products[i].count;

         });}
         console.log(this.total);
          this.totalw = this.total.weight.toFixed(2); 
          this.final = this.total.price;
          this.realFinal = this.final;
      }).catch(d=>{
        if( d.status == 503){
          this.api.onFail('Your session is expired please login again','Login');
          this.api.setGoto();
          this.api.setlogin(0);
          this.api.logout();
          setTimeout(() => {
          this.router.navigate(['/login']);
          },1000);
        } else{
          console.log(d);
        }
  });
    }
    getadd(id){
      this.clicked = id;
    }
  
    createjson(payment='cod',transaction=''){
      let masterjson = {}
      let childjson = {};
      if(this.api.igst){
      childjson['SGST'] = 0;
      childjson['IGST'] = (this.total.igst).toFixed(2);
      childjson['CGST'] = 0;
      }else{
        childjson['SGST'] = (this.total.sgst).toFixed(2);
        childjson['IGST'] = 0;
        childjson['CGST'] = (this.total.cgst).toFixed(2);
      }
      childjson['sgst_per'] = '0';
      childjson['cgst_per'] = '0';
      childjson['igst_per'] = '0';
      this.feedback ? childjson['feedback'] = this.feedback : childjson['feedback'] = '';
      childjson['transaction_id'] = transaction;
      childjson['paymentMode'] = payment;
      this.disamt ? childjson['discount_amount'] = this.disamt.toFixed(2) : childjson['discount_amount'] = '' ;
      this.discountamount ? childjson['coupanCode'] = this.discountamount.coupan : childjson['coupanCode'] = '';
      childjson['userid'] = this.api.uid.toString();
      childjson['address_id'] = this.clicked.toString();
      childjson['final_total'] = this.final.toFixed(2);
      childjson['total'] = this.realFinal.toFixed(2);
      let i = 0;
      this.products.forEach(element => {

        if(this.api.igst){
          element['SGST'] = 0;
          element['CGST'] = 0;
          element['instate'] = 0;
          }else{
            element['instate'] = 1;
            element['IGST'] = 0;
          }
        delete element['cart_id'];
        delete element['image'];
        delete element['price'];
        element['userid'] = element['user_id'];
        element['productId'] = element['product_id'];
        element['productType'] = element['jwellery_type'];
        element['size'] = element['product_size'];
        element['defaultColor'] = element['selectedColor'];
        element['totalMakingCharge'] = element['count'] * this.priceWeight[i].making;
        console.log(this.priceWeight[i]);
        element['productTotal'] = element['count'] * this.priceWeight[i].price;
        
        element.assests.forEach(element2 => {
            element2['option'] = element2['options'];
            element2['productId'] = element2['product_id'];
            delete element2['options'];
            delete element2['product_size'];
            delete element2['wastage'];
            delete element2['cart_id'];
            delete element2['id'];
            delete element2['selectedColor'];
            delete element2['product_id'];
        });
        delete element['selectedColor'];
        delete element['color'];
        delete element['product_size'];
        delete element['default_size'];
        delete element['jwellery_type'];
        delete element['product_id'];
        delete element['user_id'];
        i += 1; 
      });
      childjson['data'] = this.products;
      masterjson['calculation'] = childjson;
      
      this.api.Post(CHECKOUT,masterjson).then(data=>{
       
        this.api.onSuccess('Your Order is Successfully Placed','Thankyou');
        this.router.navigate(['/account/orders']);
        this.api.Cart.emit("cartUpdate"+Date.now());
      }).catch(d=>{
        if( d.status == 503){
          this.api.onFail('Your session is expired please login again','Login');
          this.api.setGoto();
          this.api.setlogin(0);
          this.api.logout();
          setTimeout(() => {
          this.router.navigate(['/login']);
          },1000);
        } else{
          document.getElementById('openmodalbutton2').click();
        }
  });
    }

    doit(){
      let state:any = this.api.Getgst(this.currentAddress.pincode)
      setTimeout(() => {
        if(state.__zone_symbol__value.data)
        {
        state = state.__zone_symbol__value.data[0].state_name;
        console.log(state);
        
        }else{
          this.api.onSuccess('Available in Your area','Available');
        }
        if(state.toUpperCase() == 'MAHARASHTRA'){
         console.log(state.toUpperCase());
         this.api.igst = false;
         this.api.onSuccess('Available in Your area','Available');
         console.log(state.toUpperCase())
         this.again();
        } else if(state.toUpperCase() != 'MAHARASHTRA'){
          console.log('other');
          console.log(state.toUpperCase())
          this.api.onSuccess('Available in Your area','Available');
          this.api.igst = false;
          this.again();
        }
        },1000);
    }
  
    setadd()  {
      this.currentAddress = this.addresses.find(x => x.id == this.clicked);
      document.getElementById("mClose").click();
      this.doit();
    }
  
    addAddress(){
      this.api.setGoto();
      this.router.navigate(['/add-address']);
    }
  
    register(){
      if(this.currentAddress){
        if(this.paymnetmode=='cod'){
          this.createjson();
        } else if(this.paymnetmode=='online'){
          this.payWithRazor();
        } else{
          this.api.onFail('Please Choose a Proper Payment method','Payment Method');
        }
      } else  {
              this.api.onFail('Please Add an Address First','No Address');
          }
    }
  
    payment(value){
      if(value=='no'){
        console.log('No payment MODE');
      } else{
        console.log(value);
        this.paymnetmode = value;
        if(this.paymnetmode == "offline"){
          this.showOfflineDetails = true;
        }else{
          this.showOfflineDetails = false;
        }
      }
  
    }
  
    payWithRazor() {
      
      console.log(Math.round(Number(this.final.toFixed(2))*100));
      const options: any = {
        key: 'rzp_test_NFAvKli4cunoJu',
        amount: Math.round(Number(this.final.toFixed(2))*100), // amount should be in paise format to display Rs 1255 without decimal point
        currency: 'INR',
        name: 'Gouri Gold', // company name or product name
        description: '',  // product description
        image: '../../assets/img/logo.png', // company logo or product image
      //  order_id: val, // order_id created by you in backend
        modal: {
          // We should prevent closing of the form when esc key is pressed.
          escape: false,
        },
        notes: {
          // include notes if any
        },
        theme: {
          color: '#efa300'
        }
      };
      options.handler = ((response, error) => {
        options.response = response;
        this.transaction = response.razorpay_payment_id;
         this.createjson('online',response.razorpay_payment_id)
        console.log(this.transaction);
        console.log(options);
        // call your backend api to verify payment signature & capture transaction
      });
      options.modal.ondismiss = (() => {
        // handle the case when user closes the form while transaction is in progress
        console.log('Transaction cancelled.');
      });
      const rzp = new this.winRef.nativeWindow.Razorpay(options);
      rzp.open();
    }
    ngOnInit() {
    }
  
  }
